import { render, staticRenderFns } from "./PosAtendimento.vue?vue&type=template&id=ec6e4648&scoped=true"
import script from "./PosAtendimento.vue?vue&type=script&lang=js"
export * from "./PosAtendimento.vue?vue&type=script&lang=js"
import style0 from "./PosAtendimento.vue?vue&type=style&index=0&id=ec6e4648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6e4648",
  null
  
)

export default component.exports